import { IGetMetaTagsDTO } from '@/models/metaTags.model';
import { TGetRedirectsQuery } from '../helpers/types';

class GetMetaTagsDTO implements IGetMetaTagsDTO {
  slug?: string;
  page?: number;

  constructor({
    slug,
    page,
  }: TGetRedirectsQuery & {
    page: number;
  }) {
    this.slug = slug;
    this.page = page;
  }
}

export default GetMetaTagsDTO;
